import { Card } from '@antimatterhq/ui/components/card';
import { WarehouseLocationsDropdown } from '@/components/dropdown';
import { PageHeader } from '@/components/pageHeader/PageHeader';
import {
  DataSourceHomepageSummaryCard,
  DataSourceHomepageSummaryCardErrorFallback,
  DataSourceHomepageSummaryCardSkeleton,
} from '@/pages/home/_partials/DataSourceHomepageSummaryCard';
import {
  AlertsHomepageSummaryCard,
  AlertsHomepageSummaryCardErrorFallback,
  AlertsHomepageSummaryCardSkeleton,
} from '@/pages/home/_partials/AlertsHomepageSummaryCard';
import {
  ObservablesHomepageSummaryCard,
  ObservablesHomepageSummaryCardErrorFallback,
  ObservablesHomepageSummaryCardSkeleton,
} from '@/pages/home/_partials/ObservablesHomepageSummaryCard';
import {
  NotablesHomepageSummaryCard,
  NotablesHomepageSummaryCardErrorFallback,
  NotablesHomepageSummaryCardSkeleton,
} from '@/pages/home/_partials/NotablesHomepageSummaryCard';
import { SuspenseErrorBoundary } from '@/components/errorBoundary/SuspenseErrorBoundary';
import { PageBody } from '@/components/pageBody/PageBody';
import { useInitializationCheck } from '@/hooks/initialization/useInitializationCheck';

export default function Home() {
  const { initialized } = useInitializationCheck();

  if (!initialized) {
    return null;
  }

  return (
    <>
      <PageHeader pageTitle="Home">
        <div className="flex h-9 items-center border-b border-gray-300">
          <div className="flex-grow" />
          <WarehouseLocationsDropdown className="mb-auto" />
        </div>
      </PageHeader>

      <PageBody>
        <div className="h-full">
          <Card className="mt-2 flex h-full flex-col gap-4 rounded-md bg-grey-50 p-4 dark:bg-grey-700 md:flex-row">
            <div className="grid h-full w-full gap-4 md:w-1/2">
              <SuspenseErrorBoundary
                errorBoundaryFallback={
                  DataSourceHomepageSummaryCardErrorFallback
                }
                suspenseFallback={<DataSourceHomepageSummaryCardSkeleton />}
              >
                <DataSourceHomepageSummaryCard />
              </SuspenseErrorBoundary>

              <SuspenseErrorBoundary
                errorBoundaryFallback={NotablesHomepageSummaryCardErrorFallback}
                suspenseFallback={<NotablesHomepageSummaryCardSkeleton />}
              >
                <NotablesHomepageSummaryCard />
              </SuspenseErrorBoundary>

              <SuspenseErrorBoundary
                errorBoundaryFallback={AlertsHomepageSummaryCardErrorFallback}
                suspenseFallback={<AlertsHomepageSummaryCardSkeleton />}
              >
                <AlertsHomepageSummaryCard />
              </SuspenseErrorBoundary>
            </div>
            <div className="w-full md:w-1/2">
              <SuspenseErrorBoundary
                errorBoundaryFallback={
                  ObservablesHomepageSummaryCardErrorFallback
                }
                suspenseFallback={<ObservablesHomepageSummaryCardSkeleton />}
              >
                <ObservablesHomepageSummaryCard />
              </SuspenseErrorBoundary>
            </div>
          </Card>
        </div>
      </PageBody>
    </>
  );
}
